


































import {Component, Vue} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {CustomerStore} from '@/store/CustomerStore';
import {SecurityUtils} from '@/oauth/SecurityUtils';

@Component({
  components: {},
})
export default class KeShangMain extends Vue {
  cs = getModule(CustomerStore);

  su = SecurityUtils;

  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }

  get id() {
    return this.$route.params.id as string;
  }


  private mounted() {
    return;
  }
}
